'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'industry-windows';
var width = 576;
var height = 512;
var aliases = [127981,"industry-alt"];
var unicode = 'f3b3';
var svgPathData = 'M48 32L32 32l0 16 0 208 0 128 0 80 0 16 16 0 480 0 16 0 0-16 0-144 0-64 0-128 0-25.4-22.9 11L368 187.1l0-59.1 0-25.9-23.2 11.6L192 190.1 192 48l0-16-16 0L48 32zM64 256L64 64l96 0 0 152 0 25.9 23.2-11.6L336 153.9l0 58.6 0 25.4 22.9-11L512 153.4 512 256l0 64 0 128L64 448l0-64 0-128zm64 48l-16 0 0 16 0 64 0 16 16 0 64 0 16 0 0-16 0-64 0-16-16 0-64 0zm16 64l0-32 32 0 0 32-32 0zm96-64l0 16 0 64 0 16 16 0 64 0 16 0 0-16 0-64 0-16-16 0-64 0-16 0zm32 32l32 0 0 32-32 0 0-32zm112-32l-16 0 0 16 0 64 0 16 16 0 64 0 16 0 0-16 0-64 0-16-16 0-64 0zm16 64l0-32 32 0 0 32-32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustryWindows = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;